export default __webpack_public_path__ + "static/media/icon-money.8ec88bb1.png";